import { page } from '$app/stores'
import { activeMenuParent } from '$lib/components/menu/activeMenuParent'
import { derived } from 'svelte/store'

export const isCurrentPage = derived([page, activeMenuParent], ([$page, $activeMenuParent]) => {
	return (pathname: string, parent = false) => {
		return $page.url.pathname === pathname || (parent && $activeMenuParent === pathname)
	}
})
